// extracted by mini-css-extract-plugin
export default {"root":"_1vGf4","transform":"_2Ulo0","swipeable":"_1F2Io","preview":"I28Oz","next":"_3S-BR","prev":"_2_nkd","loading":"_30mPd"};